import { CSSProperties } from "react";
import styles from "./Checkbox.module.css";

type checkBoxProps = {
    htmlText: string;
    name: string;
    required: boolean;
    changeCallback?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    autoChecked?: boolean;
    style?: CSSProperties | undefined;
};

export const Checkbox = ({
    htmlText,
    name,
    required,
    changeCallback,
    autoChecked,
    style,
}: checkBoxProps) => {
    return (
        <div className={styles.checkboxAndTerms}>
            <div className={styles.checkboxContainer}>
                <input
                    className={
                        autoChecked ? styles.hiddenCheckbox : styles.checkbox
                    }
                    aria-label={`Checkbox ${name}`}
                    type="checkbox"
                    name={name}
                    required={!autoChecked && required}
                    checked={autoChecked || undefined}
                    onChange={changeCallback}
                />
            </div>
            <div
                className={
                    autoChecked
                        ? styles.checkboxOnlyTextContainer
                        : styles.checkboxTextContainer
                }
                style={style}
                dangerouslySetInnerHTML={{ __html: htmlText }}
            />
        </div>
    );
};
